import { Group, Text } from "@mantine/core";
import { type ComponentPropsWithoutRef, forwardRef } from "react";
interface ItemProps extends ComponentPropsWithoutRef<"div"> {
  label: string;
  dropdownLabel?: string;
  chrisKey?: string;
  contactNumber?: string;
  isLabel?: boolean;
}

const CustomSelectItem = forwardRef<HTMLDivElement, ItemProps>(
  (
    {
      label,
      dropdownLabel,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- omitted from the rest props on purpose
      chrisKey,
      contactNumber,
      isLabel,
      ...others
    }: ItemProps,
    ref,
  ) => (
    <div
      ref={ref}
      {...others}
      style={
        isLabel ? { pointerEvents: "none", cursor: "default" } : undefined
      }>
      <Group noWrap>
        <div style={{ flex: 1 }}>
          <Text
            size="sm"
            c="text"
            fw={isLabel ? 200 : undefined}
            style={{ textTransform: "inherit" }}>
            {dropdownLabel ?? label}
          </Text>
          {contactNumber && (
            <Text size="xs" c="text" style={{ textTransform: "inherit" }}>
              {`Contact: ${contactNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")}`}
            </Text>
          )}
        </div>
      </Group>
    </div>
  ),
);

export default CustomSelectItem;
